/**
 * @desc 导出头程汇总表
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(
  params: API.wms.allocationMaster.exportAllocationHead.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/allocationMaster/exportAllocationHead`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
